<div class="content">
    <ngx-spinner bdColor="rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="false">
    </ngx-spinner>
    <div class="card-data">
        <div class="main-title">
            <span class="title-text">{{'meli.catalogo.title'|translateTA}}</span>
            <div class="spacer"></div>
            <span class="form-field">
                <nz-input-group [nzSuffix]="clearSuffix">
                    <input nz-input [placeholder]="'meli.catalogo.searchPlaceholder'|translateTA" type="text" [(ngModel)]="inputData" (keypress)="buscarEnter($event)" />
                </nz-input-group>
                <ng-template #clearSuffix>
                    <nz-icon nzType="close-circle" class="field-action" *ngIf="inputData" nz-tooltip [nzTooltipTitle]="'meli.form.clear'|translateTA" (click)="inputData=''" />
                </ng-template>
            </span>
            <span class="button-field">
                <button nz-button nzType="primary" nzShape="circle" nz-tooltip [nzTooltipTitle]="'meli.wizard.searchTooltip'|translateTA" (click)="buscar()" [disabled]="inputData==''">
                    <nz-icon nzType="search" />
                </button>
            </span>
        </div>
        <div class="card-content">
            <div class="variation-inner-grid" [ngStyle]="{'height': getSize('H'),'width': getSize('W')}">
                <div class="variation-inner-grid-col" *ngFor="let item of columns">
                    <div class="button-variation" *ngIf="item.colid>1 && item.children_ids.length==0">
                        <button nz-button nzType="primary" tabindex="-1" type="button" (click)="selectData(item)">
                            {{'meli.wizard.choose'|translateTA}}
                        </button>
                    </div>
                    <div *ngIf="item.colid<=1" class="button-variation">

                    </div>
                    <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{item:item}"></ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #itemTemplate let-lines="item" let-principal="principal">
    <div class="variation-grid-simple">
        <div *ngFor="let item of lines.data;let i=index" class="lines" [ngStyle]="{'height':i==0?'140px':'60px'}">
            <div class="columns-grid" [ngStyle]="{'height':i==0?'140px':'60px'}">
                <div class="data-left bold" *ngIf="lines.colid==0 && i >=1">
                    {{item.name}}
                </div>
                <div class="data-left" *ngIf="lines.colid!=0 && i >=1">
                    {{item.name}}
                </div>
                <div class="foto" *ngIf="lines.colid!=0 && i ==0 && !hideImage">
                    <carousel arrowsOutside="true" [dots]="false" cellsToShow="1" cellWidth="55" height="120" width="55">
                        <div class="carousel-cell" *ngFor="let image of item.name">
                            <img [src]="image.url">
                        </div>
                    </carousel>
                </div>
            </div>
        </div>
    </div>
</ng-template>
